import React, { useCallback, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

const SearchComponent = ({ onSearchChange, searchClass, clear, initialValue = '' }) => {
  const [query, setQuery] = useState(initialValue);

  useEffect(() => {
    setQuery(initialValue);
  }, [initialValue]);

  useCallback(() => {
    onSearchChange(query);
  }, [onSearchChange, query]);

  useEffect(() => {
    // debounce search input
    const timeout = setTimeout(() => {
      onSearchChange(query);
    }, 300);
    
    return () => clearTimeout(timeout);
  }, [query] );

  useEffect(() => {
    setQuery('');
  }, [clear])

  return (
    <div className={searchClass ?? 'px-4 py-2 border rounded-md flex flex-row items-center'}>
      <FontAwesomeIcon icon={faMagnifyingGlass} className="text-gray-400 mr-2" />
      <input 
        className="focus:outline-none bg-transparent placeholder:text-gray-400"
        type="text" 
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Search..."
      />
    </div>
  );
}

export default SearchComponent;